import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type {
  ApprovalListItemInterface,
  ApprovalListParamsInterface,
  ApprovalListPaginationInterface,
  ApprovalStatsDataInterface,
  ApprovalFilterValueInterface,
} from 'features/ApprovalEngine/@types/ApprovalListTypes'

interface ApprovalEngineListStateType {
  isLoading: boolean
  isLoadingList: boolean
  stats: ApprovalStatsDataInterface
  components: ApprovalFilterValueInterface[]
  workflows: ApprovalFilterValueInterface[]
  list: ApprovalListItemInterface[]
  pagination: ApprovalListPaginationInterface
  params: ApprovalListParamsInterface
}

const initialState: ApprovalEngineListStateType = {
  isLoading: false,
  isLoadingList: false,
  stats: {
    total: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
  },
  components: [],
  workflows: [],
  list: [],
  pagination: {
    page_size: 10,
    page_item: 0,
    previous_cursor: '',
    next_cursor: '',
    next_page_exist: false,
    previous_page_exist: false,
    cursor_direction: '',
    page_cursor: '',
  },
  params: {
    view: '',
    page_size: 10,
    cursor: '',
    cursor_direction: '',
  },
}

const approvalEngineListSlice = createSlice({
  name: 'approvalEngineList',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsLoadingList: (state, action: PayloadAction<boolean>) => {
      state.isLoadingList = action.payload
    },
    setStats: (state, action: PayloadAction<ApprovalStatsDataInterface>) => {
      state.stats = action.payload
    },
    setComponents: (state, action: PayloadAction<ApprovalFilterValueInterface[]>) => {
      state.components = action.payload
    },
    setWorkflows: (state, action: PayloadAction<ApprovalFilterValueInterface[]>) => {
      state.workflows = action.payload
    },
    setList: (state, action: PayloadAction<ApprovalListItemInterface[]>) => {
      state.list = action.payload
    },
    setPagination: (state, action: PayloadAction<ApprovalListPaginationInterface>) => {
      state.pagination = action.payload
    },
    setParams: (state, action: PayloadAction<ApprovalListParamsInterface>) => {
      state.params = { ...state.params, ...action.payload }
    },
    resetApprovalEngineList: () => initialState,
  },
})

export const {
  setIsLoading,
  setIsLoadingList,
  setStats,
  setComponents,
  setWorkflows,
  setList,
  setPagination,
  setParams,
  resetApprovalEngineList,
} = approvalEngineListSlice.actions

export default approvalEngineListSlice.reducer
